import React, { useEffect } from 'react';

import { syncService } from '@/utils/syncService';

export const GlobalSyncManager: React.FC = () => {
  useEffect(() => {
    // Run cleanup on app startup to free space from inactive engagements
    const runStartupCleanup = async () => {
      try {
        await syncService.cleanupInactiveEngagements();
      } catch (error) {
        console.warn('[App] Startup cleanup failed:', error);
        // Don't block app startup if cleanup fails
      }
    };

    // Run cleanup on app start
    runStartupCleanup();

    // Start the global auto-sync service
    syncService.startAutoSync();
    
    // Cleanup when component unmounts (app closes)
    return () => {
      syncService.stopAutoSync();
    };
  }, []);

  // This component doesn't render anything
  return null;
};
